var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon", { attrs: { "with-card": true } }),
      _vm._v(" "),
      !_vm.$store.getters.isExecutingRequest
        ? _c("div", [
            !_vm.isSubscribed
              ? _c("div", { staticClass: "card shadow-sm" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-8" }, [
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "pages.admin.users.information.not_subscribed"
                              )
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  ])
                ])
              : _c("div", [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("h4", { staticClass: "card-title mb-3" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("pages.subscription.title")) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-10" }, [
                          _c("p", {
                            staticClass: "mb-0",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "pages.admin.users.information.subscribed"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.users.information.subscribed_duration"
                                  ) +
                                    _vm
                                      .$date(_vm.subscribedAt)
                                      .format("DD.MM.YYYY")
                                ) +
                                "\n                            "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-2 text-center" }, [
                          _c("i", {
                            staticClass: "mdi mdi-96px mdi-check-decagram",
                            class: [
                              _vm.onGracePeriod
                                ? "text-warning"
                                : "text-primary"
                            ]
                          })
                        ])
                      ])
                    ])
                  ])
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 text-right" }, [
      _c("i", { staticClass: "mdi mdi-48px text-danger mdi-account-remove" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }